import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { InsightObjectViewPanelSkeleton } from '@atlassian/jira-skeletons/src/ui/insight-object/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyObjectAttachmentsPanel = lazyForPaint(
	() => import(/* webpackChunkName: "insight-object-attachments-panel" */ './ui'),
);

export const AsyncObjectAttachmentsPanel = () => (
	<Placeholder
		name="insight-object-attachments-panel"
		fallback={<InsightObjectViewPanelSkeleton />}
	>
		<LazyObjectAttachmentsPanel />
	</Placeholder>
);
